

export function deviceBrowserCheck() {
  function addTabletPortraitClassToMain() {
    const ua = navigator.userAgent.toLowerCase()
    const platform = navigator.platform
    const maxTouchPoints = navigator.maxTouchPoints
  
    const isIpad = /ipad/.test(ua)
      || (platform === 'MacIntel' && maxTouchPoints > 1) // iPadOS 判定
      || (ua.includes('macintosh') && 'ontouchend' in document) // 念のため追加
  
    const isAndroidTablet = /android/.test(ua) && !/mobile/.test(ua)
    const isPortrait = window.matchMedia('(orientation: portrait)').matches
  
    const main = document.querySelector('main')
    const body = document.querySelector('body')
    if (!main || !body) return
  
    if ((isIpad || isAndroidTablet) && isPortrait) {
      // main.classList.add('is_tb_ver')
      body.classList.add('is_tb_ver')
      // console.log('✅ <main> に is_tb_ver クラス追加')
    } else {
      // main.classList.remove('is_tb_ver')
      body.classList.remove('is_tb_ver')
      // console.log('タブレットじゃない')
    }
  }

  // 初回実行
  addTabletPortraitClassToMain()

  // リサイズ・画面回転にも対応
  window.addEventListener('resize', addTabletPortraitClassToMain)
  window.addEventListener('orientationchange', addTabletPortraitClassToMain)
  
  // デバイス判定
  function isMobileDevice() {
    return /iPhone|iPad|iPod|Android|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
  if (isMobileDevice()) {
    document.body.classList.add('is_mobile');
  }
  if (navigator.userAgent.includes("Windows")) {
    document.body.classList.add("is_windows");
  }
  const userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1) {
    // Internet Explorer
    console.log('Internet Explorerをお使いですね');
  } else if (userAgent.indexOf('edg') !== -1) {
    // Microsoft Edge
    // console.log('Edgeをお使いですね');
  } else if (userAgent.indexOf('chrome') !== -1 && userAgent.indexOf('safari') !== -1 && userAgent.indexOf('edg') === -1) {
    // Google Chrome (Edgeを除外)
    // console.log('Google Chromeをお使いですね');
  } else if (userAgent.indexOf('safari') !== -1 && userAgent.indexOf('chrome') === -1) {
    // Safari
    document.body.classList.add('is_safari');
    // console.log('Safariをお使いですね');
  } else if (userAgent.indexOf('firefox') !== -1) {
    // Firefox
    document.body.classList.add('is_ff');
    // console.log('Firefoxをお使いですね');
  } else if (userAgent.indexOf('opera') !== -1 || userAgent.indexOf('opr') !== -1) {
    // Opera
    // console.log('Operaをお使いですね');
  } else {
    // その他のブラウザ
    // console.log('そんなブラウザは知らん');
  }
}
